<div
  class="columns small-12 medium-8"
  data-tms-event="popup-click-impression"
  data-tms-popup-zone="internet.settings"
  data-tms-popup-name="MACIP"
>
  <p data-cy="fixedIpDescription">
    {{ 'internet.settings.fix.ip.mac.address.description' | translate }}
  </p>
  <form data-abide="ajax" novalidate="novalidate" (ngSubmit)="updateOrAddMacIpAddress()">
    <div class="rs-form-item">
      <input
        type="text"
        data-cy="fixedIpInputField"
        id="ac-macaddress"
        [(ngModel)]="fixedIpMacAddress"
        #newMacAddressInput="ngModel"
        name="macaddress"
        (ngModelChange)="validateMacAddress()"
        placeholder=""
        aria-describedby="ac-macaddress-helper0"
        required=""
        [ngClass]="{ 'rs-filled': !isNewMacAddressEmpty() }"
        [disabled]="pending"
      />

      <label class="rs-form-label" for="ac-macaddress" data-cy="fixedIpLabel">{{
        'internet.settings.fix.ip.mac.address.label' | translate
      }}</label>

      <span
        class="rs-form-error"
        *ngIf="!isMacAddressValid && !newMacAddressInput.pristine"
        id="ac-macaddress-error0"
        >{{ 'internet.settings.fix.ip.mac.address.error' | translate }}</span
      >

      <span class="rs-form-helper" id="ac-macaddress-helper0">{{
        'internet.settings.fix.ip.mac.address.example' | translate
      }}</span>
    </div>

    <button
      class="rs-btn"
      type="submit"
      data-tms-button-name="apply"
      data-cy="fixedIpButton"
      [disabled]="!isMacAddressValid || pending"
      [ngClass]="{ 'rs-btn-disabled': !isMacAddressValid || pending }"
    >
      {{ 'internet.settings.fix.ip.mac.address.button' | translate }}
    </button>

    <px-alert [alertKey]="'updateFixedIpAlert'" data-cy="fixedIpConfirmation"></px-alert>
  </form>
  <p>
    <button
      class="rs-link-action rs-link-action-remove"
      type="button"
      data-tms-button-name="delete"
      (click)="deleteMacIpAddress()"
      [disabled]="!isMacAddressValid || pending"
    >
      <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">{{
        'internet.settings.fix.ip.mac.address.delete' | translate
      }}</span
      ><span class="rs-action-link-icon" title="Delete your registered MAC Address"
        ><span class="show-for-sr">{{
          'internet.settings.fix.ip.mac.address.delete' | translate
        }}</span></span
      >
    </button>
  </p>
</div>
